import { useState } from "react";

import { useProgrammeContext } from "hooks/useProgrammeContext";
import { useAuthContext } from "hooks/useAuthContext";
import { API_URL } from "../../config";

export const useDeleteProgramme = () => {
  const { user } = useAuthContext();
  const { programmes, dispatch } = useProgrammeContext();

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const deleteprogramme = async (id) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${API_URL}/programmes/deleteprogramme/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (!response.ok) {
        const json = await response.json();
        throw new Error(json.error);
      }

      const json = await response.json();
      console.log(json);
      dispatch({ type: "DELETE_PROGRAMME", payload: id });
      setSuccess("Programme deleted successfully");
    } catch (error) {
      setError(error.message || "An error occurred when deleting programme");
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteprogramme, isLoading, error, success, setError, setSuccess };
};
